import D2C_ServiceData from './Data'

class D2C_ServiceMongoDB extends D2C_ServiceData {
  static objectType = 'serviceType'
  static active = true
  static order = 23
  static typeName = 'mongodb'
  static typeTitle = 'MongoDB'
  static color = '#33aa44'
  static methods = {
    ...D2C_ServiceData.methods,
    backupDatabase: true,
    resetPassword: true,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceData.fields,
    configs: {
      ...D2C_ServiceData.fields.configs,
      default: [
        {name: 'mongo.yml', text: require('raw-loader!@/assets/configs/mongodb-mongo.yml').default, custom: false},
      ],
      variables: [...D2C_ServiceData.fields.configs.variables, '$mongoAuth', '$mongoKeyfile', '$mongoReplication'],
    },
    configuration: {
      default: 'StandAlone',
      enum: [
        {value: 'StandAlone', text: 'StandAlone'},
        {value: 'ReplicaSet', text: 'ReplicaSet'},
      ],
      label: 'Configuration',
      path: 'configuration',
      required: false,
      validate() {
        return null
      },
      creating: {},
      migrating: {
        readonly: true,
        required: true,
      },
      importing: {},
    },
    hosts: {
      ...D2C_ServiceData.fields.hosts,
      selector: {
        StandAlone: ['master'],
        ReplicaSet: ['master', 'slave'],
      },
      validate(value, entity) {
        if (entity.configuration === 'ReplicaSet') {
          const masters = entity.hosts.filter(host => host.role === 'master')
          const slaves = entity.hosts.filter(host => host.role === 'slave')
          const containers = entity._containers || []
          if (!masters.length && !entity.created) {
            return 'Master host is not selected'
          }
          if (containers.length < 2 && slaves.length < 2) {
            return 'Must be selected at least two slaves'
          }
          if (containers.length > 1 && slaves.length < 1) {
            return 'Must be selected at least one slave'
          }
          if (value.length > 51) {
            return 'Available only 51 selected hosts'
          }
        }
        return (value && value.length > 0) ? null : 'Must be selected at least one host'
      },
    },
    image: {
      ...D2C_ServiceData.fields.image,
      default: 'mongo',
    },
    password: {
      default: '',
      label: 'Superuser password',
      path: 'password',
      required: false,
      superuser: 'root',
      width: 9,
      validate(value, entity, mode) {
        if (mode === 'migrating' && entity.hasPassword) {
          return null
        }
        if (entity.remoteAccess && !value) {
          return 'Database with remote access must have a password!'
        }
        if (entity.configuration === 'ReplicaSet' && !entity.hasPassword && !value) {
          return 'Database in the ReplicaSet mode must have a password!'
        }
        if ((value || this.required) && value.length < 6) {
          return 'Minimum length is 6 symbols'
        }
        return null
      },
      creating: {},
      importing: {},
      migrating: {
        required: true,
      },
      resetingPassword: {
        autoselect: true,
        label: 'New superuser password',
        required: true,
      },
    },
    ports: {
      ...D2C_ServiceData.fields.ports,
      default: [
        {protocol: 'TCP', value: 27017},
      ],
    },
    version: {
      ...D2C_ServiceData.fields.version,
      default: '5.0',
      enum: ['4.2', '4.4', '5.0'],
    },
    volumes: {
      ...D2C_ServiceData.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/data', dst: '/data/db', sync: false},
        {src: '/ebs/containers/$serviceName/configs', dst: '/data/configdb', sync: false},
      ],
    },
  }
}

export default D2C_ServiceMongoDB
